import { Field, FieldProps } from 'formik';
import Input from '../ui/Input';

type InputFormikProps = {
  name: string;
  isDisabled?: boolean;
  type?: React.HTMLInputTypeAttribute;
  label?: string;
  startAdornment?: string;
  endAdornment?: string;
  rows?: number;
  maxRows?: number;
  isRequired?: boolean;
  placeholder?: string;
  isTextArea?: boolean;
  autoComplete?: string;
  autoFocus?: boolean
};

const InputFormik = (props: InputFormikProps) => (
  <Field name={props.name}>
    {(field: FieldProps) => (
      <div>
        <label htmlFor={props.name} className="block mb-2 text-sm font-medium text-gray-300">
          {props.label}
        </label>
        <Input
          name={props.name}
          type={props.type}
          placeholder={props.placeholder}
          isRequired={props.isRequired}
          value={field.field.value}
          onChange={field.field.onChange}
          onBlur={field.field.onBlur}
          autoComplete={props.autoComplete}
          isTextArea={props.isTextArea}
          autoFocus={props.autoFocus}
        />

        {field.form.errors[field.field.name] && field.form.touched[field.field.name] && (
          <p className="text-red-700 text-sm mt-1">{field.form.errors[field.field.name]}</p>
        )}
      </div>
    )}
  </Field>
);

export default InputFormik;
